import React from "react";
import { HeroSection, ServicesSection, LearnSection } from "./sections";

const Home = () => (
  <>
    <HeroSection />
    <ServicesSection />
    <LearnSection />
  </>
);

export default Home;
